export default __webpack_public_path__ + "static/media/partners.f839c190.webp";